import { Theme } from "@mui/material";
import { gridClasses } from "@mui/material/Grid";

const contactStyle = {
  link: {
    margin: "0 auto",
    display: "block",
    textAlign: "center",
    width: 170,
  },
  grid: (theme: Theme) => ({
    [`& > .${gridClasses.root}`]: {
      [theme.breakpoints.up("md")]: {
        padding: "12px",
      },
      minWidth: 320,
    },
  }),
  callIcon: {
    display: "block",
    margin: "0 0 0 auto",
    width: 40,
    height: 40,
    padding: "8px",
  },
  callGridItem: {
    marginTop: "1.5rem",
  },
  headline: {
    textAlign: "center",
    fontSize: "1.25rem",
    marginTop: "3rem",
  },
  moreButton: {
    marginTop: "1rem",
  },
};

export default contactStyle;
